// extracted by mini-css-extract-plugin
export default {"background":"Layout_background__YN9Xx","support":"Layout_support__s63Md"};